export const menuBoxShadow = '1px 0 2px rgba(0, 0, 0, 0.1)'
